import { notifyAuthSessionChanged } from 'services/auth/session';
import { IOrganization, IUser } from 'types';

const logoutUser = (
  setUser: (user: IUser | null) => void,
  setCurrentOrganization: (currentOrganization: IOrganization | null) => void,
): void => {
  notifyAuthSessionChanged();
  setUser(null);
  setCurrentOrganization(null);
  localStorage.removeItem('accessToken');
  localStorage.removeItem('modalDisplayed');
  localStorage.removeItem('refreshToken');
};

export { logoutUser };
